{
  "settings": "Iestatījumi",
  "yourDigitalAssistant": "Jūsu digitālais palīgs",
  "getStarted": "Sāc",
  "login": "Pieslēgties",
  "loggingIn": "Ielogoties ...",
  "darkMode": "Tumšais režīms",
  "clearHistory": "Notīrīt vēsturi",
  "historyCleared": "Vēsture ir notīrīta",
  "changeLanguage": "Valoda",
  "termsAndConditions": "Lietošanas noteikumi",
  "messagePlaceholder": "Ierakstiet savu ziņojumu šeit ...",
  "messagePlaceholderDisabled": "Rakstīšana ir atspējota ...",
  "feedbackTitle": "Novērtējiet savu pieredzi",
  "feedbackPlaceholder": "Pastāstiet mums par to (pēc izvēles)",
  "feedbackSend": "Nosūtīt",
  "feedbackClose": "Aizvērt",
  "sessionExpired": "Jūsu sesija ir beigusies neaktivitātes dēļ.",
  "startNewSession": "Sāciet jaunu sesiju",
  "apiError": "Hmm ... Kaut kas nogāja greizi. Mēs strādājam pie tā, lai pēc iespējas ātrāk to novērstu.",
  "apiErrorOffline": "Jums nav savienojuma ar internetu.",
  "tryAgain": "Mēģini vēlreiz",
  "startOver": "Sāciet no jauna",
  "chatEnded": "Tērzēšana ir beigusies.",
  "chatEndedThankYou": "Paldies, ka tērzējat ar mums!",
  "closeChat": "Aizvērt",
  "startNewChat": "Atkal tērzējiet",
  "humanTakeoverStarted": "Jūs tagad tiekat nodots klientu apkalpošanai ...",
  "humanTakeoverQueued": "Gaida savienojumu ar aģentu",
  "humanTakeoverAnAgent": "Aģents",
  "humanTakeoverAgentEntered": "ienācu sarunā",
  "humanTakeoverAgentLogout": "pameta sarunu",
  "humanTakeoverTransfer": "Jūs tiekat pārcelts uz jaunu aģentu",
  "humanTakeoverEnded": "Jūs tagad tērzējat ar savu digitālo palīgu",
  "version": "Versija",
  "formIntroText": "Lūdzu, aizpildiet šo veidlapu, lai sāktu tērzēt ar mums.",
  "formFirstName": "Vārds",
  "formLastName": "Uzvārds",
  "formName": "Nosaukums",
  "formEmail": "E-pasts",
  "formWrongEmail": "Lūdzu, norādiet derīgu e-pasta adresi.",
  "formPhone": "Tālrunis",
  "formShipmentId": "Sūtījuma ID",
  "formQuestion": "Tavs jautājums",
  "formAccountNumber": "Konta numurs (biznesa klientiem)",
  "formAddress": "Adrese",
  "formPostcode": "Pasta indekss",
  "formCity": "Pilsēta",
  "formCountry": "Valstī",
  "formSubmitButton": "Sāciet tērzēšanu",
  "formEmptyFieldError": "Nav atļauts būt tukšs.",
  "formPhoneNumberValidationError": "Nav derīgs tālruņa numurs.",
  "formInputIsBiggerThan50": "Jābūt ne vairāk kā 50 rakstzīmēm.",
  "formInputIsBiggerThan100": "Jābūt ne vairāk kā 100 rakstzīmēm.",
  "formInputIsBiggerThan2000": "Jābūt ne vairāk kā 2000 rakstzīmēm.",
  "widgetEventOnline": "DA ziņojums: lietotājs atkal ir tiešsaistē.",
  "widgetEventHidden": "DA ziņojums: Logrīks ir paslēpts.",
  "widgetEventVisible": "DA ziņojums: Logrīks ir redzams.",
  "widgetEventVisibleMinimized": "DA ziņojums: Logrīks ir redzams, taču ir samazināts līdz minimumam.",
  "widgetEventMinimized": "DA ziņojums: Logrīks ir samazināts līdz minimumam.",
  "widgetEventMaximized": "DA ziņojums: Logrīks ir maksimizēts.",
  "widgetEventSessionExpired": "DA ziņojums: Logrīka sesijas derīguma termiņš ir beidzies.",
  "widgetEventHangupHuman": "DA ziņojums: lietotājs beidz cilvēka pārņemšanas sesiju.",
  "widgetEventUserTyping": "DA ziņojums: lietotājs raksta.",
  "fileTooLarge": "Jūs mēģināt pievienot pārāk lielus failus.",
  "tooManyDiles": "Jūs mēģināt pievienot pārāk daudz failu.",
  "fileInvalidType": "Jūs mēģināt pievienot nederīgus failu tipus.",
  "attachmentsDropHere": "Nometiet šeit, lai augšupielādētu vai",
  "attachmentsBrowse": "Pārlūkot failus",
  "attachmentsExtenstionQuantity": "pdf vai attēli (līdz 10 failiem)",
  "attachmentsSize": "līdz 30 MB",
  "attachmentsFailedUploading": "Augšupielāde neizdevās",
  "attachmentsUploading": "Notiek augšupielāde ...",
  "minimizeExpandText": "Tiešraides tērzēšana ar mums tagad!",
  "popupWidgetNotificationMessage": "Jūs saņēmāt jaunu ziņojumu!",
  "tabWidgetNotificationMessage": "Jauna ziņa!",
  "datepickerSendButton": "Sūtīt"
}
